import { LoadingButton } from "@mui/lab";
import { Box, Divider, TextField, Typography, Alert } from "@mui/material";
import GoogleIcon from "@mui/icons-material/Google";
import WindowIcon from "@mui/icons-material/Window";
import React, { useState, useContext, useEffect } from "react";
import DarkLogo from "../assets/DarkLogo.png";
import { logging, validateUsername, validatePassword } from "../utils/Login";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../GlobalContext";
import LanguageSwitcher from "../LanguageSwitcher";

// const getBackground = (theme) => {
// 	const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

// 	switch (theme) {
// 		case "light":
// 			return isMobile ? "transparent" : grey[50];
// 		case "dark":
// 			return isMobile ? "transparent" : grey[900];
// 		default:
// 			return "transparent";
// 	}
// };

// const getBorder = (theme) => {
// 	const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

// 	switch (theme) {
// 		case "light":
// 			return isMobile ? "none" : "1px solid rgba(0, 0, 0, 0.12)";
// 		case "dark":
// 			return isMobile ? "none" : "1px solid rgba(255, 255, 255, 0.12)";
// 		default:
// 			return "none";
// 	}
// };

export const Login = () => {
	const { t } = useTranslation();
	const { setAuthenticated, getModuleId } = useContext(GlobalContext);

	const [username, setUsername] = useState({
		value: "",
		error: false,
		helperText: "",
	});
	const [password, setPassword] = useState({
		value: "",
		error: false,
		helperText: "",
	});

	const [credentialsError, setCredentialsError] = useState({
		error: false,
		message: "",
	});

	const [loading, setLoading] = useState(false);

	const [isEmbedded, setIsEmbedded] = useState(false);

	useEffect(() => {
		setIsEmbedded(window.location.search.includes("embedded=true"));

		// Si quieres detectar si está dentro de un iframe
		// setIsEmbedded(window.self !== window.top);
	}, []);

	useEffect(() => {
		if (isEmbedded) {
			setAuthenticated(true);
		}
	}, [isEmbedded, setAuthenticated]);

	return (
		<>
			<Box
				sx={{
					width: 400,
					padding: 7,
					borderRadius: 5,
					border: 1,
					borderColor: "secondary.main",
				}}
			>
				<LanguageSwitcher />
				<form
					onSubmit={(event) => {
						// Pasa los valores de username y password como argumentos
						logging(
							event,
							setLoading,
							username.value, // Solo el valor del username
							password.value, // Solo el valor del password
							setAuthenticated,
							getModuleId, // <-- Ahora en la posición correcta
							setCredentialsError,
							isEmbedded
						);
					}}
				>
					<center>
						<img
							src={DarkLogo}
							alt="logo-app"
							height={50}
							width={180}
							style={{
								marginTop: 20,
								marginBottom: 40,
							}}
						/>
					</center>

					<TextField
						id="username"
						label={t("sign_on.form.username")}
						type="username"
						variant="outlined"
						fullWidth
						value={username.value}
						onChange={(event) => {
							if (validateUsername(event.target.value)) {
								setUsername({
									value: event.target.value,
									error: false,
									helperText: "",
								});
							} else {
								setUsername({
									value: event.target.value,
									error: true,
									helperText: event.target.value
										? t("sign_on.form.invalid_username")
										: t("sign_on.form.empty_username"),
								});
							}
						}}
						error={username.error}
						helperText={username.helperText}
					/>

					<TextField
						sx={{ mt: 2 }}
						id="password"
						type="password"
						label={t("sign_on.form.password")}
						variant="outlined"
						fullWidth
						value={password.value}
						onChange={(event) => {
							if (validatePassword(event.target.value)) {
								setPassword({
									value: event.target.value,
									error: false,
									helperText: "",
								});
							} else {
								setPassword({
									value: event.target.value,
									error: true,
									helperText: event.target.value
										? t("sign_on.form.invalid_password")
										: t("sign_on.form.empty_password"),
								});
							}
						}}
						error={password.error}
						helperText={password.helperText}
					/>
					{credentialsError.error && (
						<Alert severity="error" sx={{ mt: 2 }}>
							{credentialsError.message}
						</Alert>
					)}

					<LoadingButton
						sx={{ mt: 3, mb: 3, height: 50 }}
						type="submit"
						fullWidth
						variant="contained"
						color="primary"
						loading={loading}
						disableElevation
						disabled={username.error || password.error}
					>
						{t("sign_on.form.sign_on")}
					</LoadingButton>

					<Divider>
						<Typography>{t("sign_on.form.or")}</Typography>
					</Divider>

					<LoadingButton
						sx={{ mt: 3, height: 50 }}
						fullWidth
						variant="contained"
						color="primary"
						loading={false}
						disableElevation
						endIcon={<GoogleIcon />}
						disabled={true}
					>
						{t("sign_on.form.sign_in_with")}
					</LoadingButton>

					<LoadingButton
						sx={{ mt: 3, height: 50 }}
						fullWidth
						variant="contained"
						color="primary"
						loading={false}
						disableElevation
						endIcon={<WindowIcon />}
						disabled={true}
					>
						{t("sign_on.form.sign_in_with")}
					</LoadingButton>

					<Typography sx={{ mt: 4, textAlign: "center" }}>
						{t("sign_on.form.version")}: 0.0.1b
					</Typography>
				</form>
			</Box>
		</>
	);
};
